import axios from "axios";

export const state = {
    reportproductsdemands: [],
};

export const getters = {
    reportproductsdemands: state => state.reportproductsdemands,
};

export const mutations = {
    setReportProductsDemand(reportproductsdemands, newValue) { state.reportproductsdemands = newValue},
};

export const actions = {
    fetchReportProductsDemand({ commit }) {
        axios.get('/reportproductsdemands').then(res => {
            commit('setReportProductsDemand', res.data.demands)
        })
    },
    filterReportProductsDemand({commit}, {datefrom,dateto}) { 
        let formData = new FormData();
        formData.append("datefrom", datefrom);
        formData.append("dateto", dateto);
        let url = "/filterreportproductsdemands";
        axios.post(url, formData).then((response) => {
            commit('setReportProductsDemand', response.data.demands)
        })
    },
};
